import { minorToMajor } from "../currency/currency.ts";

export function formatRmb(minor: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "CNY",
    maximumFractionDigits: 0,
  })
    .format(minorToMajor(minor, "RMB"))
    .replace("CN¥", "RMB ");
}
